import type { Currency } from '@etiquetachef/types';
import { serverDate } from '@etiquetachef/ui-shared/online';

/**
 * Formatadores do admin. Portados de `@etiquetachef/ui-shared` para zerar a
 * dependência do pacote shadcn no admin (Sprint 39 — UI 100% Cloudscape).
 * Implementações idênticas às originais; esta é a fonte local canônica.
 */

/** Centavos → moeda formatada no locale (`12990, 'BRL'` → `R$ 129,90`). */
export function formatPriceCents(cents: number, currency: Currency, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(cents / 100);
}

/** Epoch ms → data e hora curtas no locale do navegador (fuso local). */
export function formatDateTime(millis: number, locale: string): string {
  return new Date(millis).toLocaleString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Epoch ms → data curta no locale (fuso local). */
export function formatDate(millis: number, locale: string): string {
  return new Date(millis).toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** Bucket mensal "YYYYMM" do instante atual (UTC). */
export function currentYyyymm(now: Date = serverDate()): string {
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, '0');
  return `${String(y)}${m}`;
}

/** Emoji bandeira a partir de código ISO-3166 alpha-2 (ex: "BR" → "🇧🇷"). */
export function countryFlag(code: string | null | undefined): string {
  if (!code || code.length !== 2) return '';
  const upper = code.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return '';
  const offset = 0x1f1e6 - 'A'.charCodeAt(0);
  return String.fromCodePoint(upper.charCodeAt(0) + offset, upper.charCodeAt(1) + offset);
}
